import classNames from 'classnames/bind';
import { Button, EduSummaryItem, Loading, ModalEduDelete, ModalEduEdit } from 'components';
import Scrollbar from 'libs/Scrollbar';
import { TextField, Tooltip } from 'material-ui';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { defineMessages, injectIntl } from 'react-intl';
import { Icon, Image } from 'semantic-ui-react';
import styles from './EduSummary.css';

const cx = classNames.bind(styles);

class EduSummary extends Component {
  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      eduSummaryOrdering,
      eduSummaryByEduNo,
      isClicked,
      isLoading,
      isOpen,
      selectEduNo,
      selectEditEduNo,
      eduExamByExamNo,
      eduExamOrdering,
      examNoArray,
      formStoreEdit
    } = this.props;
    // function
    const {
      onSelectEduSummary,
      onSelectEachInfo,
      onToggleExamSummary,
      onEduToggleModal,
      handleChangeExam
    } = this.props;
    // modal
    const { isModal, onToggleModal, onDeleteEdu, onPutEdu } = this.props;
    // 필터
    const { filter } = this.props;

    // search
    const { searchProps } = this.props;
    const EduSummaryComponent = [];

    if (eduSummaryOrdering.size > 0) {
      eduSummaryOrdering.map(
        // 컴포넌트로 매핑
        (eduNo, index) =>
          EduSummaryComponent.push(
            <EduSummaryItem
              key={index}
              edu={eduSummaryByEduNo.get(String(eduNo))}
              // isOpen={!!(isOpen.indexOf(Number(eduNo)) !== -1)}
              selected={String(selectEduNo) === String(eduNo)}
              onSelectEduSummary={onSelectEduSummary}
              onSelectEachInfo={onSelectEachInfo}
              onToggleExamSummary={onToggleExamSummary}
              onEduToggleModal={onEduToggleModal}
            />
          )
      );
    }

    return (
      <div className={cx('examSummary-wrapper', 'eduSummary-wrapper')}>
        {/* 훈련 수정 모달 */}
        {isModal === 'eduEdit' && (
          <ModalEduEdit
            visible
            selectEditEduNo={selectEditEduNo}
            selectEditEduData={eduSummaryByEduNo.get(String(selectEditEduNo))}
            eduSummaryByEduNo={eduSummaryByEduNo}
            eduSummaryOrdering={eduSummaryOrdering}
            onPutEdu={onPutEdu}
            eduExamByExamNo={eduExamByExamNo}
            eduExamOrdering={eduExamOrdering}
            examNoArray={examNoArray}
            isLoading={isLoading}
            isClicked={isClicked}
            formStoreEdit={formStoreEdit}
            handleChangeExam={handleChangeExam}
            onToggleModal={onToggleModal}
          />
        )}
        {/* 훈련 삭제 모달 */}
        {isModal === 'eduDelete' && (
          <ModalEduDelete
            visible
            selectEditEduNo={selectEditEduNo}
            eduSummaryByEduNo={eduSummaryByEduNo}
            eduSummaryOrdering={eduSummaryOrdering}
            onDeleteEdu={onDeleteEdu}
            isLoading={isLoading}
            isClicked={isClicked}
            onToggleModal={onToggleModal}
          />
        )}
        <div className={cx('examSummary-title')}>
          {isLoading && (
            <div className={cx('Loading')}>
              <Loading content={'Loading...'} noInverted />
            </div>
          )}
          <div>
            <div className={cx('examSummary-title-inner', 'examSummary-all', { selected: selectEduNo === 'all' })}>
              <div className={cx('title-inner')} onClick={e => onSelectEduSummary('all')}>
                <div className={cx('bt-exam-all')}>
                  <Image className={cx('ui image')} src="/img/exam/cate_all.png" />
                  <span>{defineMessages(formatMessage({ id: 'EduHeader_1', defaultMessage: '전체 교육' }))}</span>
                </div>
              </div>
              <div className={cx('tag-title-bt-area')}>
                <Tooltip
                  title={defineMessages(formatMessage({ id: 'ExamSearch_17', defaultMessage: '검색' }))}
                  placement="bottom">
                  <Image
                    src="/img/target/ico_search.png"
                    className={cx('bt-tagFunc', { selected: searchProps.isSearchActive })}
                    onClick={searchProps.onSearchActive}
                  />
                </Tooltip>
              </div>
            </div>
            {searchProps.isSearchActive && (
              <div className={cx('search-area')}>
                <div className={cx('serach-inner')}>
                  <TextField
                    autoFocus
                    className={cx('input-search')}
                    value={searchProps.searchText}
                    onChange={searchProps.onChangeSearch}
                    onKeyUp={searchProps.onKeyupSearch}
                    onKeyUp={searchProps.onKeyupSearch}
                    onChange={e => searchProps.onChangeSearch(e.target.value)}
                    inputRef={searchProps.searchTextRef}
                    onBlur={searchProps.onSearchBlur}
                  />
                  <Button
                    className={cx('bt-icon')}
                    icon
                    title={defineMessages(formatMessage({ id: 'ExamSearch_17', defaultMessage: '검색' }))}
                    size="small"
                    onClick={e => {
                      e.stopPropagation();
                      searchProps.onSearch();
                    }}>
                    <Icon name="search" />
                  </Button>
                  <Button
                    className={cx('bt-icon')}
                    icon
                    title={defineMessages(formatMessage({ id: 'TagItem_2', defaultMessage: '취소' }))}
                    size="small"
                    onClick={e => {
                      e.stopPropagation();
                      searchProps.onClearSearch();
                    }}>
                    <Icon name="cancel" />
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className={cx('examSummary-content')}>
          {/* <Scrollbar autoHide color="white"> */}
            <div className={cx('examSummary-content-inner', EduSummaryComponent.length <= 0 && 'examSummary-no-inner')}>
              <div className={cx('each-exam')}>
                {EduSummaryComponent.length > 0 ? (
                  EduSummaryComponent
                ) : (
                  <div className={cx('examSummary-noExam')}>
                    {defineMessages(formatMessage({ id: 'EduList_1', defaultMessage: '교육이 없습니다' }))}
                  </div>
                )}
              </div>
            </div>
          {/* </Scrollbar> */}
        </div>
      </div>
    );
  }
}

EduSummary.propTypes = {
  edu: ImmutablePropTypes.mapContains({
    eduNo: PropTypes.number,
    eduName: PropTypes.string,
    examCount: PropTypes.number,
    eduCount: PropTypes.number,
    eduAttachNo: PropTypes.number,
    startEpoch: PropTypes.number,
    endEpoch: PropTypes.number
  }),
  onSelectEduSummary: PropTypes.func,
  onToggleExamSummary: PropTypes.func
};

export default injectIntl(EduSummary);



// WEBPACK FOOTER //
// ./src/script/components/edu/EduSummary.js